import { createEvent, createStore, sample } from 'effector';
import { createGate } from 'effector-react';

import { messagesTypes, setMessage } from 'src/entity/Messages';
import { $firstStageVotes, PostVoteT } from 'src/entity/Pretendents';
import { $userId } from 'src/entity/User';
import { openFinalPanelAfterPostFx } from '../../../shared/lib/effects/openFinalPanelAfterPostFx/openFinalPanelAfterPostFx';
import { postVotesFx } from '../lib/effects/postVotesFx/postVotesFx';

export const PostVotesGate = createGate();

const setIsPosting = createEvent<boolean>();
export const $isPosting = createStore<boolean>(false);

export const postVotes = createEvent();

sample({
  clock: setIsPosting,
  target: $isPosting
});

sample({
  clock: postVotes,
  source: $firstStageVotes,
  filter: $firstStageVotes => !Object.keys($firstStageVotes).length,
  fn: () => messagesTypes.FILL_ERROR,
  target: setMessage
});

sample({
  clock: postVotes,
  source: { $firstStageVotes, $userId },
  filter: ({ $firstStageVotes }) => !!Object.keys($firstStageVotes).length,
  fn: ({ $firstStageVotes, $userId }): PostVoteT => ({
    ...$firstStageVotes,
    vkId: String($userId)
  }),
  target: postVotesFx
});

sample({
  clock: postVotesFx.failData,
  fn: () => messagesTypes.POST_ERROR,
  target: setMessage
});

sample({
  clock: postVotesFx.pending,
  fn: () => true,
  target: setIsPosting
});

sample({
  clock: [postVotesFx.done, postVotesFx.fail],
  fn: () => false,
  target: setIsPosting
});

sample({
  clock: postVotesFx.doneData,
  target: openFinalPanelAfterPostFx
});
